import { types } from '../actions/form11';

export const {INIT_DOCUMENTS, ADD_DOCUMENT, REMOVE_DOCUMENT, RESET_DOCUMENTS } = types;
const initState = { documents: [] };

export const form11Reducer = () => (state = initState, action) => {
	switch (action.type) {
		case INIT_DOCUMENTS: {
			return {documents: action.payload}
		}
		case ADD_DOCUMENT: {
			return { ...state, documents: [...state.documents, action.payload] }
		};
		case REMOVE_DOCUMENT: {
			return {
				...state, documents: [...state.documents.filter(doc => (
					doc.documentType !== action.payload
				))]
			}
		};
		case RESET_DOCUMENTS: {return initState}
		default: return state;
	}
};
